/** Needed for @i18n/next */
"use client";

import type { ComponentProps } from "react";
import { IntlErrorCode, IntlProvider } from "use-intl";

import { consoleErrorI18nReact } from "../utils/consoleErrorI18nReact";

export type I18nProviderProps = ComponentProps<typeof IntlProvider> & {
  isOnErrorMessagesWithUnderscoresOnly?: boolean;
};

export const I18nProvider = ({
  children,
  isOnErrorMessagesWithUnderscoresOnly,
  ...props
}: I18nProviderProps) => {
  /**
   * Handle errors on messages with underscores ONLY
   */
  if (isOnErrorMessagesWithUnderscoresOnly)
    props.onError = (error) => {
      if (
        error.code === IntlErrorCode.MISSING_MESSAGE &&
        error.originalMessage?.includes("_")
      )
        consoleErrorI18nReact({
          heading: `${error.originalMessage} (${error.code})`,
          error: error.message,
        });
    };

  return (
    <IntlProvider timeZone="UTC" {...props}>
      {children}
    </IntlProvider>
  );
};
